// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownCaratIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DownCarat",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.13 7.73c-.64 0-1.23.26-1.65.69s-.68 1.02-.68 1.67.26 1.24.68 1.67l11.67 11.83c.42.43 1 .69 1.65.69s1.23-.27 1.65-.69l11.67-11.83c.42-.43.68-1.02.68-1.67s-.26-1.24-.68-1.67-1-.69-1.64-.69z"
    })
  });
};